import {iFrameConnection} from "./services/IFrameConnection";
import {IFrameMessages} from "../blink-sdk/messaging/IFrameMessages";
import {authService, userService} from "../client/connection/Services";
import {iFrameState} from "./services/IFrameState";
import {iFrameMerchantService} from "./services/IframeMerchantService";
import {BUILD_TIMESTAMP, BUILD_VERSION, IFRAME_APP_TYPE, PANEL_TYPE, TEST_MODE} from "../blink-sdk/Constants";
import {PaywallApp} from "./paywall/PaywallApp";
import {WidgetApp} from "./widget/WidgetApp";
import {iFrameAnalyticsService} from "./services/IFrameAnalyticsService";
import {EventSender} from "../blink-sdk/utils/AnalyticsClient";
import {iFrameAuthService} from "./services/IFrameAuthService";
import {iFrameMetadataModule} from "./services/IFrameMetadataModule";
import {GlobalState} from "../stem-core/src/state/State";
import {BlinkGlobal} from "./UtilsLib";
import {AutomationHelper} from "./AutomationHelper";


const eventsReceivedFromIFrames = new WeakSet();

function initGlobalStateSync() {
    let applyingClearEvent = false;

    iFrameConnection.addIframesListener(IFrameMessages.UPDATE_GLOBAL_STATE, ({event}) => {
        eventsReceivedFromIFrames.add(event);
        if (event.type === "clear") {
            applyingClearEvent = true;
            GlobalState.getStore(event.objectType).clear();
            applyingClearEvent = false;
        } else {
            // TODO(@mihai): State import events should be reusable.
            if (event.type === "fakeCreate") {
                event.type = "create";
            }
            GlobalState.applyEvent(event);
        }
    });

    for (const store of GlobalState.stores.values()) {
        store.addChangeListener((obj, event) => {
            if (event == null) {
                // Prevent infinite recursion.
                if (applyingClearEvent) {
                    return;
                }
                event = {type: "clear", objectType: store.objectType};
            }
            if (!eventsReceivedFromIFrames.has(event)) {
                iFrameConnection.sendToIFrames(IFrameMessages.UPDATE_GLOBAL_STATE, {event});
            }
        });
    }
}

export function initIFrameApp({publicData, iframeParams, merchantId, merchantToken, oneCountUserId, appType}) {
    iFrameConnection.setAppType(appType);
    authService.setPublicData(publicData);
    iFrameState.init(iframeParams);
    iFrameMerchantService.init(merchantId);
    iFrameAuthService.init(merchantToken);
    iFrameAnalyticsService.init(appType === IFRAME_APP_TYPE.widget
        ? EventSender.wallet
        : EventSender.paywall);
    iFrameMetadataModule.init();

    if (TEST_MODE && !window.Bundle && appType === IFRAME_APP_TYPE.widget) {
        window.Bundle = {AutomationHelper};
    }

    const initIframeApp = () => {
        const iframeAppClass = appType === IFRAME_APP_TYPE.paywall ? PaywallApp : WidgetApp;
        initGlobalStateSync();
        iframeAppClass.init();
    }

    const executeInit = async () => {
        BlinkGlobal.appType = appType;
        if (authService.isAuthenticated()) {
            userService.ensureUserDataRequested(initIframeApp);
        } else {
            if (oneCountUserId != null) {
                try {
                    await authService.loginAtEndpoint("/external_providers/login_with_one_count_user/", {
                        oneCountUserId,
                    });
                } finally {
                    initIframeApp();
                }
            } else {
                initIframeApp();
            }
        }
    };
    const canExecuteInit = () => iFrameState.panelType !== PANEL_TYPE.payment || iFrameState.paymentDetails;

    if (!canExecuteInit()) {
        const listener = iFrameState.addUpdateListener(() => {
            if (canExecuteInit()) {
                listener.remove();
                executeInit();
            }
        })
    } else {
        executeInit();
    }
}
